export function loadState() {
  try {
    const serializedState = window.localStorage.getItem("certState");
    if (serializedState === null) {
      return undefined;
    }
    const parsed = JSON.parse(serializedState);

    const auth = parsed?.auth;
    if (!auth) {
      window.localStorage.removeItem("certState");
      return undefined;
    }

    const expire = auth.user?.access?.access_token_expire;
    if (expire && Date.now() / 1000 > expire) {
      window.localStorage.removeItem("certState");
      return undefined;
    }

    return { auth };
  } catch (err) {
    return undefined;
  }
}

export function saveState(state) {
  try {
    const serializedState = JSON.stringify(state);
    window.localStorage.setItem("certState", serializedState);
  } catch (e) {
    console.error(e);
  }
}
